<template  lang='pug'>
v-flex(:class="classObj")
  .body-2(:align="component.align ? component.align : 'justify'") {{ t(this.id, component.label) }}
</template>

<script>
  export default {
    name: 'u-label',
    props: {
      id: {
        type: String
      },
      component: {
        type: Object,
        required: true
      },
      resultForm: {
        type: Object
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/form/inputs/Label.vue